import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as CKEditor from '@ckeditor/ckeditor5-build-classic';
import { AuthService } from '../services/auth.service';
import { QuestionsService } from '../services/questions.service';

@Component({
  selector: 'app-askquestions',
  templateUrl: './askquestions.component.html',
  styleUrls: ['./askquestions.component.css']
})


export class AskquestionsComponent implements OnInit {
  public Editor = CKEditor;
  questions: any;
  errMess: Error;
  error: Boolean;
  newquestion: string;
  islogged: Boolean;
  user: any;
  constructor(private questionService: QuestionsService, private router: Router, private authService: AuthService) {
   }
  ngOnInit() {
    this.authService.getUserdetail().subscribe(res=>{
      this.user = res;
     // console.log(this.user);
      this.getQuestionSet();
    });
    
      this.islogged = this.authService.isLoggedIn();
      //console.log(this.islogged);
  }

  getQuestionSet(){
    this.questions = [];
    this.user.question_set.forEach(question=>{
      this.questionService.getquestionbyID(question).subscribe(
        res=>{
          if(res){
            this.questions.push(res);
            //console.log(res);
            //console.log(this.questions);
          }
        },error=>{
         // console.log(error);
          this.errMess = error;
          this.error = true;
        }
      );
    });
    //console.log(this.questions);
  }
  sendQuestion(val){
    //console.log(val.value);
    this.newquestion = val.value;
    if(this.islogged){
      this.questionService.postUserquestion(this.newquestion).subscribe(
        res=>{
          if(res){
           // console.log("Question Posted:" + this.newquestion);
            this.ngOnInit();
          }
        },error=>{
         // console.log(error);
        }
      );
    }
    else{
      this.router.navigateByUrl("/login");
    }
  }

  getanswer(i){
    const id = this.questions.results[i].id;
    this.router.navigateByUrl('/getanswers/'+id); 
  }
}
